export const getOpenTraining = (state) => {
  return state.openTraining;
};
